//Api service
import api from "../config/api";

export const fetchProductImage = async () => {
  const res = await api.get(`/productimage/`);
  return res.data.data;
};
export const fetchProductImageByProductId = async (productId) => {
  const res = await api.get(`/productimage/?productId=${productId}`);
  return res.data.data;
};
export const createProductImage = async (formData) => {
  const res = await api.post(`/productimage/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.data;
};
export const updateProductImage = async (id, data) => {
  const res = await api.post(`/productimage/?id=${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.data;
};
export const deleteProductImage = async (id) => {
  const res = await api.delete(`/productimage/?id=${id}`);
  return res.data.data;
};
